import type { IBookmark } from "~/models/ILegalTextParagraph";

export function useLocalBookmarks() {
  return useLocalStorage<IBookmark[]>("local-bookmarks", [], {
    initOnMounted: true,
  });
}
